"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const hauler_types_1 = require("./hauler.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        contractor_id: '',
        contractor_name: '',
        contractor: {
            id: '',
            contractor_code: '',
            contractor_name: '',
            contractor_type: '',
            is_active: {
                status: 'Active',
                value: true
            },
            modified_by: '',
            modified_date: new Date(),
            created_by: '',
            created_date: new Date(),
        },
        hauler_no: '',
        hauler_spec: '',
        is_active: {
            value: true,
            status: 'Active'
        },
        modified_by: '',
        modified_date: new Date(),
        created_by: '',
        created_date: new Date(),
        rfid_tag: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const haulerReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hauler_types_1.haulerTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hauler_types_1.haulerTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates,
            dataGrid, isLoading: false });
    },
    [hauler_types_1.haulerTypes.GET_DETAIL]: (state, action) => {
        const dataContractor = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractor });
    },
    [hauler_types_1.haulerTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [hauler_types_1.haulerTypes.ON_DELETE]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [hauler_types_1.haulerTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoading: true, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [hauler_types_1.haulerTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hauler_types_1.haulerTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [hauler_types_1.haulerTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError, errorCode, errorMessage, isLoading: false });
    },
    [hauler_types_1.haulerTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    }
});
exports.default = haulerReducer;
